/**
 * Calculate total flight cost including all cost components and CNX/MOD costs.
 *
 * @param {object} flight - Flight object with cost fields
 * @returns {string} Total cost as formatted string with 2 decimal places
 *
 * Requirements: 7.1, 7.2, 7.3, 7.4
 */
export const calculateTotalCost = (flight) => {
  // Safe numeric coercion: treat non-numeric values as 0
  const safeNum = (val) => {
    const n = Number(val || 0);
    return Number.isNaN(n) ? 0 : n;
  };

  // Calculate sum of base costs (flightCost, xbagCost, otherTransportCost, hotelCost)
  const baseCosts =
    safeNum(flight.xbagCost) +
    safeNum(flight.flightCost) +
    safeNum(flight.otherTransportCost) +
    safeNum(flight.hotelCost);

  // Calculate sum of all cnxModCosts from cnxModCosts array
  // Handle null/undefined cnxModCosts array (treat as 0)
  const cnxModCostsArray = flight.cnxModCosts || [];
  const cnxModCostsSum = cnxModCostsArray.reduce((sum, entry) => {
    // Handle null/undefined cost values (treat as 0)
    return sum + safeNum(entry?.cost);
  }, 0);

  // Return total as formatted string with 2 decimal places
  return (baseCosts + cnxModCostsSum).toFixed(2);
};
